export function capitalize (value:string) {
  return value.charAt(0).toUpperCase() + value.slice(1)
}

export function implode (arr: Array<string>) {
  return arr.join(', ')
}

export function excerpt (text: string, limit: number) {
  return text.length > limit ? `${text.substring(0, limit)}...` : text
}
